<template>
  <nuttrema-layout-west-slide width="30%" minWidth="40em">
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: 'diet-schedules' }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->
    <div class="east-block">
      <nuttrema-loader
         v-if="ProgramDetails.fetching"
        :showText="false">
      </nuttrema-loader>

      <nuttrema-empty-result
        v-else-if="ProgramDetails.notFound"
        icon="fal fa-exclamation-triangle">
        <template slot="text">
          <h1 v-html="$t('label.item_not_found')"></h1>
          <h4 v-html="$t('label.item_not_found_text')"></h4>
        </template>
      </nuttrema-empty-result>

      <manage-program-days
         v-else
        :id="id"
        :dayID="dayID"
        :ProgramDetails="ProgramDetails"
        @cancel="onCancelEvent"
        @submit="onSubmitEvent">
      </manage-program-days>
    </div>
  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';

import { PROGRAMS_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';
import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import ManageProgramDays from './cmpt-manage-program-days';

export default {
  name: 'page-manage-program-days',
  mixins: [
    PageProps,
  ],
  components: {
    ManageProgramDays,
    WestSlideLeftNavigation,
    NuttremaLayoutWestSlide,
    NuttremaIconicaSidebarLink,
  },
  props: {
    id: {
      required: false,
      default: null,
    },
    dayID: {
      required: true,
      default: null,
    },
    type: {
      required: false,
      default: PROGRAMS_KEYS.diet,
    },
  },
  computed: {
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
  },
  methods: {
    ...mapActions([
      'ManageProgramDays',
    ]),
    onSubmitEvent(payload) {
      console.log('onFormSubmit', payload);
      this.ManageProgramDays({
        id: this.id,
        type: this.type,
        payload,
      })
      .then(() => {
        console.log('save was successfully!');
        this.successNotification({ message: 'message.success_program_days_save' });
        this.onSuccessEvent({ dayID: this.dayID });
      })
      .catch((error) => {
        console.error(error);
        this.errorNotification({ message: 'message.error_program_days_save' });
      });
    },
  },
  beforeDestroy() {
    this.$store.dispatch('ClearProgramDetailsSaveError', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/manage/page-manage-diet-days.vue